import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { Header, Lists } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { riwayatPresensiUrl } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSessionExpired } from "../../helpers/Toast";

const RiwayatPresensi = () => {
  const { handleSessionExpired } = useAuth();
  const navigate = useNavigate();
  const [tglawal, settglawal] = useState(new Date());
  const [tglakhir, settglakhir] = useState(new Date());
  const [riwayat, setriwayat] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const getRiwayat = async (awal, akhir) => {
    const body = {
      tanggal_awal: moment(awal).format("yyyy-MM-DD"),
      tanggal_akhir: moment(akhir).format("yyyy-MM-DD"),
      jenis_presensi: "REGULER",
    };

    try {
      setIsLoading(true);
      const response = await fetch(riwayatPresensiUrl, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        showError("Gagal memuat riwayat presensi");
        return;
      }

      const data = await response.json();
      setriwayat(data.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const onfilter = (date, type) => {
    if (type === "awal") {
      settglawal(date);
      getRiwayat(date, tglakhir);
    } else {
      settglakhir(date);
      getRiwayat(tglawal, date);
    }
  };

  useEffect(() => {
    getRiwayat(tglawal, tglakhir);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Riwayat Presensi</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Riwayat Presensi" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        {/* Filter tanggal */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 mb-2">
          <div className="flex items-center gap-3">
            <div className="flex-1">
              <p className="text-xs text-gray-400 mb-1 font-medium">Tanggal Awal</p>
              <DatePicker
                className="w-full text-sm font-semibold text-gray-700 bg-gray-50 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 border border-gray-200"
                selected={tglawal}
                onChange={(date) => onfilter(date, "awal")}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <div className="text-gray-400 font-bold text-sm mt-4">—</div>
            <div className="flex-1">
              <p className="text-xs text-gray-400 mb-1 font-medium">Tanggal Akhir</p>
              <DatePicker
                className="w-full text-sm font-semibold text-gray-700 bg-gray-50 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 border border-gray-200"
                selected={tglakhir}
                onChange={(date) => onfilter(date, "akhir")}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
        </div>

        {/* List */}
        {isLoading ? (
          <div className="space-y-3 mt-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl h-24 animate-pulse" />
            ))}
          </div>
        ) : riwayat && riwayat.length > 0 ? (
          riwayat.map((item, index) => (
            <Lists
              riwayatpresensi
              key={index}
              text={item.tgl}
              text2={item.jam_masuk == null ? "-- : --" : moment(item.jam_masuk, "HH:mm:ss").format("HH:mm")}
              text3={item.status_berangkat}
              text4={item.jam_pulang == null ? "-- : --" : moment(item.jam_pulang, "HH:mm:ss").format("HH:mm")}
              text5={item.status_pulang}
            />
          ))
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-10 mt-2 text-center">
            <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <p className="text-sm text-gray-400">Tidak ada riwayat presensi</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiwayatPresensi;
